import { kea } from "kea";
import api from '../utils/api';

export const keylogic = kea({
	actions: {
		fetchAll: true,
		rename: (key) => ({ key }),

		setAll: (keys) => ({ keys }),
		setOne: (key) => ({ key }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		keys: [null, {
			setAll: (_, { keys }) => keys,
			setOne: (state, { key }) => state.map((s) => s._id === key._id ? key : s),
		}],
		loading: [false, {
			fetchAll: () => true,
			rename: () => true,

			setAll: () => false,
			setOne: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/key';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		rename: async ({ key }, breakpoint) => {
			await breakpoint(300);
			let url = `/key/${key._id}/rename`;
			let res;
			try {
				res = await api({ url, method: 'put', body: key });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				actions.setSuccess('Key Updated.');
			} else actions.setError(json.error);
		}
	})
});

export default keylogic;
